export default __webpack_public_path__ + "static/topNavItems-anatomy-light-bd8103f2ea67f9529e5d5b8467bde248.png";